import { useNavigate } from 'react-router-dom';
import '../styles/play.css';

/* Adorian's front door: /real-or-fake/modes

   The one URL he bookmarks. Left goes to something Alyssa or Jason built for him; right runs
   the endless pool. Two targets, both enormous, because this is operated at arm's length from
   a recording chair rather than leaned over with a mouse.

   Deliberately spare. Everything on this screen could end up in frame while he gets set up, so
   there is no chrome, no sign-out button, no counts and no internal wording. */

export default function ModesHome() {
  const navigate = useNavigate();

  return (
    <div className="modes" data-testid="modes-home">
      <div className="round-title">Real or Fake?</div>
      <div className="modes-grid">
        <button className="mode-card" onClick={() => navigate('/modes/series')} data-testid="mode-premade">
          <span className="mode-kicker">Pick one</span>
          <span className="mode-name">Premade Series</span>
          <span className="mode-note">A set built for you, in order.</span>
        </button>
        <button className="mode-card endless" onClick={() => navigate('/modes/endless')} data-testid="mode-endless">
          <span className="mode-kicker">Just go</span>
          <span className="mode-name">Endless Mode</span>
          <span className="mode-note">Keep going until you stop.</span>
        </button>
      </div>
    </div>
  );
}
